import { Component, OnInit, ViewEncapsulation } from "@angular/core";


@Component({
    selector: 'app-header',
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {
    showMenu: boolean = false;
    constructor() {
    }

    ngOnInit(): void {

    }

    fnShowMenu(show) {
        this.showMenu = show;
    }

    clickedOutside(event: boolean) {
        if (event) {
            this.showMenu = false;
        }
    }
}
